import { createSlice } from "@reduxjs/toolkit";

const initialNasState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: {total : 0},
  links: null,
  currency: null,
  lastError: null,
  nasForEdit: undefined,
  nasForExport: []
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const nasSlice = createSlice({
  name: "nas",
  initialState: initialNasState,
  reducers: {
		catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
		nasFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
		nasAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    nasCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.nas.push(action.payload.nas);
    },
    nasDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.nas.filter(el => el.nas_id !== action.payload.id);
    },
    getNas: (state, action) => {
      state.actionsLoading = false;
      state.nasForEdit = action.payload.nasForEdit;
      state.error = null;
    },
    getExportNas: (state, action) => {
      state.actionsLoading = false;
      if(action.payload.nasForExport === undefined) {
        state.nasForExport = [];
      }else{
        state.nasForExport.push(action.payload.nasForExport);
      }
      state.error = null;
    },
    // updateProduct
    nasUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.nas = state.entities.nas.map(entity => {
        if (entity.nas_id === action.payload.nas.nas_id) {
          return action.payload.nas;
        }
        return entity;
      });
    },
  },
});
